var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "dice",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 9",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dice__d20",
    d: "M 4.5 0.5 L 8 2.5 L 8 6.5 L 4.5 8.5 L 1 6.5 L 1 2.5 L 4.5 0.5 L 8 2.5 M 4.5 2.5 L 4.5 0.5 M 4.5 2.5 L 6.5 6 L 2.5 6 L 4.5 2.5 M 4.5 2.5 L 8 2.5 M 4.5 2.5 L 1 2.5 M 1 6.5 L 2.5 6 M 1 2.5 L 2.5 6 M 2.5 6 L 4.5 8.5 M 8 2.5 L 6.5 6 M 8 6.5 L 6.5 6 M 6.5 6 L 4.5 8.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD20);
export default __webpack_public_path__ + "static/media/d20.f114029976e497806f45afb484120a72.svg";
export { ForwardRef as ReactComponent };